export default "__VITE_ASSET__P7UvCepD__"